<template>
  <div class="d-flex flex-column border border-top-0 p-3 text-left">
    <span>※請勾選品項出貨</span>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>
            <b-form-checkbox></b-form-checkbox>
          </th>
          <th>貨品狀態</th>
          <th>出貨商品</th>
          <th>數量</th>
          <th colspan="2">出貨方式／預計出貨日</th>
          <th>收件人</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in order_ship_list" :key="index"
          :class="{isselectedShip:item.pro_isship}">
          <td>
            <b-form-checkbox :value="index" v-model="selected_ship"></b-form-checkbox>
          </td>
          <td>{{item.pro_status}}</td>
          <td>{{item.pro_name}}</td>
          <td>{{item.pro_count}}</td>
          <td>
            <div class="d-flex justify-content-between">
              <span>{{item.pro_ship_method}}</span>
              <span>{{item.pro_ship_method2}}</span>
            </div>
          </td>
          <td>{{item.pro_ship_date}}</td>
          <td>{{item.pro_receiver}}</td>
        </tr>
        <tr>
          <td colspan="3">合計</td>
          <td colspan="4">8件（6件未排出）</td>
        </tr>
        <tr>
          <td rowspan="2" colspan="2">本次出貨設定</td>
          <td colspan="5">
            <div class="d-flex align-items-center">
              <div>
                <select class="form-control">
                  <option>出貨方式</option>
                  <option>現場領取</option>
                </select>
              </div>
              <div>
                <select class="form-control">
                  <option>出貨條件</option>
                  <option>現領</option>
                </select>
              </div>
              <div>
                <select class="form-control">
                  <option>預定日期, 時段｜今天</option>
                  <option>2020-04-08, 全天</option>
                </select>
              </div>
              <div>
                <a v-if="!address" href="#" @click.prevent="changeAddress()">不變更地址</a>
                <a v-else href="#" @click.prevent="changeAddress()">變更地址</a>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td v-if="address" colspan="5">
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center">
                  <span>收件人</span>
                  <div>
                    <b-form-input></b-form-input>
                  </div>
                </div>
                <div class="d-flex align-items-center ml-5">
                  <span>聯絡電話</span>
                  <div>
                    <b-form-input></b-form-input>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center">
                  <span>收件地址</span>
                  <div>
                    <select class="form-control">
                      <option>235新北至中和區</option>
                    </select>
                  </div>
                </div>
                <div class="d-flex align-items-center ml-5">
                  <div class="ml-5 pl-3">
                    <b-form-input></b-form-input>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="7">
            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center">
                <div><button type="button" class="btn btn-outline-secondary">清除</button></div>
                <div><button type="button" class="btn btn-outline-secondary">僅儲存不排出貨</button></div>
              </div>
              <div class="d-flex align-items-center">
                <span>已勾選2項目（共4件貨品）</span>
                <div><button type="button" class="btn btn-outline-secondary"
                    @click="toShip()">出貨</button></div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected_id: [],
      address: false,
    };
  },
  methods: {
    changeAddress() {
      if (this.address) {
        this.address = false;
      } else {
        this.address = true;
      }
    },
    showMsgBoxOne(index) {
      console.log(index);
      this.boxOne = '';
      this.$bvModal.msgBoxOk('Action completed')
        .then((value) => {
          this.boxOne = value;
        });
    },
    toShip() {
      for (let i = 0; i < this.selected_ship.length; i += 1) {
        if (this.order_ship_list[this.selected_ship[i]].pro_status === 'pre_order') {
          this.showMsgBoxOne(i);
          break;
        } else {
          this.$store.commit('ship/changeIsship', this.selected_ship[i]);
        }
      }
      // this.selected_ship.forEach((element) => {
      //   if (this.order_ship_list[element].pro_status === 'pre_order') {
      //     this.showMsgBoxOne(element);
      //   } else {
      //     this.$store.commit('ship/changeIsship', element);
      //   }
      // });
    },
  },
  computed: {
    order_ship_list: {
      get() {
        return this.$store.state.ship.order_ship_list;
      },
    },
    selected_ship: {
      get() {
        return this.$store.state.ship.selected_ship;
      },
      set(data) {
        this.$store.commit('ship/changeSelected', data);
      },
    },
  },
};

</script>

<style lang="scss">
  .isselectedShip {
    background-color: red;
  }

</style>
